import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { ArrowDownIcon, UserPlusIcon } from "@heroicons/react/24/solid";
import {
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Select,
  Option,
} from "@material-tailwind/react";
import Lottie from "lottie-react";
import animationData from "../../assets/images/Coming-Soon.json";

export default function InventoryGCP() {
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(10);

  return (
    <div className="app-main__inner !pl-20 ">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Integrations
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all monitored GCP cloud accounts
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              <Button
                className="flex items-center gap-3"
                size="sm"
                loading={isLoading === null ? true : false}
              >
                <UserPlusIcon strokeWidth={2} className="h-4 w-4" />
                <span className="hidden md:inline-block"> Create New</span>
              </Button>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                className="!border-t-0 !border-[#b0bec5]"
                label="Select Limit"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                className="!border-t-0 !border-[#b0bec5]"
                label="Sort By"
                value={sortBy}
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              <Select
                color="green"
                className="!border-t-0 !border-[#b0bec5]"
                animate={{
                  mount: { y: 0 },
                  unmount: { y: 25 },
                }}
                label="Status"
                value={status}
                onChange={(event) => {
                  setStatus(event);
                  setIsLoading(null);
                }}
              >
                <Option value="">All Data</Option>
                <Option value="active">Active</Option>
                <Option value="deactive">Deactive</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="px-3 p-5">
          <div className="flex flex-col justify-center items-center">
            <div className="w-1/2">
              <Lottie animationData={animationData} loop={true} />
            </div>
            <Typography color="gray" className="mt-1 font-normal">
              We are working on something interesting!
            </Typography>
          </div>
        </CardBody>
        {/* {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setIsLoading(null);
                  setPage(page - 1);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setIsLoading(null);
                      setPage(index + 1);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )} */}
      </Card>
    </div>
  );
}
